/*!

=========================================================
* Central System - v1.0.0
=========================================================

* Coded by Aircode

=========================================================

*/
import React from "react";
import './Manager.css'

import centralSystem from 'assets/img/mockups/central-system-mockup.png';

// reactstrap components
import {
  Container,
  Row,
  Col,
  CardImg,
  Card,
  Button,
} from "reactstrap";

class Manager extends React.Component {

  render() {
    return (
      <>
          <section className="section bg-gradient ">
            <Container className="cs-container">
              <Row className="row-grid align-items-center">
                <Col md="7">
                  <Card className="bg-transparent border-0">
                    <CardImg
                      alt="..."
                      src={centralSystem}
                      top
                    />
                   
                  </Card>
                </Col>
                <Col md="5">
                  <div className="pl-md-5 text-white">
                    
                    <h2 className="text-white cs-title">A Central System to manage everything</h2>
                    <p className="fs-6">
                        Designed for educators and therapists, it is a digital platform 
                        that provides interactive exercise and real-time feedback to empower 
                        children with autism on their journey to confident and effective learning.
                    </p>
                    <Button
                        block
                        className="btn-learn"
                        target="_blank"
                        href="/admin"
                        
                    >
                        Access Now
                    </Button>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>
      </>
    )
  }
}

export default Manager;